import { useDeviceQueryApi } from "./useDeviceQueryApi";
export function useHardwareInfo() {
  var queryApi = useDeviceQueryApi();
  return queryApi.useHardwareInfoQuery();
}